module.exports = __webpack_public_path__ + "img/stores.2872184f.png";